module.exports = __webpack_public_path__ + "img/4.105c791.png";